import { Paginated } from "../../../../common/domain/models/paginated_models";
import { ChecklistLista } from "../../domain/models/checklist_Lista";
import {
  GetDropDownChecklistRequestModel,
  GetDropDownChecklistResponseModel,
} from "../../domain/models/checklist_models";

import {
  CreateDisciplinasArquivosRequestModel,
  CreateDisciplinasArquivosResponseModel,
  DeleteDisciplinasArquivosRequestModel,
  DeleteDisciplinasArquivosResponseModel,
  GetAllDisciplinasArquivosRequestModel,
  GetAllDisciplinasArquivosResponseModel,
  GetDisciplinasArquivosByIdRequestModel,
  GetDisciplinasArquivosByIdResponseModel,
  UpdateDisciplinasArquivosRequestModel,
  UpdateDisciplinasArquivosResponseModel,
} from "../../domain/models/disciplina_arquivo_models";
import { DisciplinaFilter } from "../../domain/models/disciplina_filter";

import {
  UpdateDisciplinaChecklistRequestModel,
  UpdateDisciplinaChecklistResponseModel,
} from "../../domain/models/disciplina_item_models";
import { DisciplinaLista } from "../../domain/models/disciplina_lista";

import {
  DeleteProjetoDisciplinaRequestModel,
  DeleteProjetoDisciplinaResponseModel,
  GetDropDownDisciplinaRequestModel,
  GetDropDownDisciplinaResponseModel,
  GetProjetoDisciplinaByIdRequestModel,
  GetProjetoDisciplinaByIdResponseModel,
} from "../../domain/models/disciplina_models";
import { DisciplinasSubdisciplinasLista } from "../../domain/models/disciplinas_subdisciplinas_lista";
import { DocumentoLista } from "../../domain/models/documentos_lista";
import { InformacoesFilter } from "../../domain/models/informacoes_filter";
import { InformacoesLista } from "../../domain/models/informacoes_lista";
import { ItemChecklistLista } from "../../domain/models/ItemChecklistLista";
import { DisciplinaItemChecklistLista } from "../../domain/models/items_disciplina_checklist_lista";

import {
  GetProjetoInformacoesByIdRequestModel,
  ProjetoInformacoesGetByIdModel,
} from "../../domain/models/projeto_informacoes";

import { GetProjetoArquivoByIdRequestModel } from "../../domain/models/projeto_arquivo_model";

import { ProjetoFilter } from "../../domain/models/projetos_filter";
import { ProjetoLista } from "../../domain/models/projetos_Lista";
import { ProjetoRevisaoModel } from "../../domain/models/revisao_projeto";
import { ProjetoRevisaoLista } from "../../domain/models/revisao_projeto_lista";
import { ProjetoRevisaoResumoLista } from "../../domain/models/revisao_projeto_resumo_lista";

import { IProjetosRepository } from "../../domain/repositories/projetos_repository";
import { DisciplinaCopiaRequestForm } from "../../presentation/schemas/Projetos_cadastro/Disciplina_e_SubDisciplina_copia";
import { CreateItensChecklistResponse } from "../daos/create/create_itens_checklist";
import { CreateProjetoResponse } from "../daos/create/create_projeto";
import { CreateProjetoDisciplinaResponse } from "../daos/create/create_projeto_disciplina";
import { CreateProjetosChecklistResponse } from "../daos/create/create_projetos_checklist";
import { DeleteItensChecklistResponse } from "../daos/delete/delete_itens_checklist";
import { DeleteProjetosChecklistResponse } from "../daos/delete/delete_projetos_checklist";
import { GetItensChecklistByIdResponse } from "../daos/read/get_itens_checklist_by_id";
import { GetProjetosChecklistByIdResponse } from "../daos/read/get_projetos_checklist_by_id";
import { UpdateItensChecklistResponse } from "../daos/update/update_itens_checklist";
import { UpdateProjetosChecklistResponse } from "../daos/update/update_projetos_checklist";
import { IProjetosService } from "../services/projetos_service";
import { ProjetoImpressaoLista } from "../../domain/models/impressao_projeto_lista";
import { ImpressaoProjetoModel } from "../../domain/models/impressao_projeto";
import { EmailImpressaoParameters } from "../../domain/models/email_impressao_parameters";
import { DashboardProjetosInfo } from "../../domain/models/dashboard_projetos_info";

export class ProjetosRepository implements IProjetosRepository {
  constructor(private readonly service: IProjetosService) {}
  //#region Projeto

  async getProjetoList(
    filter: ProjetoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ProjetoLista>> {
    const response = await this.service.getProjetoList({
      ...filter,
      page,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ProjetoLista => ({
          IdProjeto: item.idProjeto,
          DescricaoProjeto: item.descricaoProjeto,
          Contato: item.contato,
          Responsavel: item.responsavel,
          CentroCustoNome: item.centroCusto,
          DataInicio: item.dataInicioPrevista,
          DataTermino: item.dataTerminoPrevista,
          Status: item.status,
          Arquivo: "",
          Contato1: "",
          Contato2: "",
          IdNovoNegocio: null,
          IdCentroCusto: null,
          NumeroContrato: null,
          TelefoneCelular: null,
          TelefoneFixo: null,
          Telefone1: null,
          Telefone2: null,
          Email1: null,
          Email2: null,
          Email: null,
          Escopo: null,
          DadosEntrada: null,
          Informacoes: null,
          Data: null,
          DataInicioReal: null,
          DataTerminoReal: null,
          NomeArquivo: null,
        }),
      ),
    };
  }

  async getProjetoById(IdProjeto: number): Promise<ProjetoLista> {
    const response = await this.service.getProjetoById({ IdProjeto });
    return {
      IdProjeto: response.idProjeto,
      DescricaoProjeto: response.descricaoProjeto,
      NumeroContrato: response.numeroContrato,
      IdCentroCusto: response.idCentroCusto,
      DataInicio: response.dataInicio,
      DataTermino: response.dataTermino,
      DataInicioReal: response.dataInicioreal,
      DataTerminoReal: response.dataTerminoreal,
      Contato1: response.contato1,
      Telefone1: response.telefone1,
      Email1: response.email1,
      Contato2: response.contato2,
      Telefone2: response.telefone2,
      Email2: response.email2,
      Escopo: response.escopo,
      DadosEntrada: response.dadosEntrada,
      Contato: null,
      Responsavel: null,
      CentroCustoNome: response.centroCustoNome,
      Status: null,
      Arquivo: null,
      IdNovoNegocio: null,
      TelefoneCelular: null,
      TelefoneFixo: null,
      Email: null,
      Informacoes: null,
      Data: null,
      NomeArquivo: null,
    };
  }

  async createProjeto(
    DescricaoProjeto: string | null,
    NumeroContrato: string | null,
    IdCentroCusto: number | null,

    DataInicio: Date | null,
    DataTermino: Date | null,
    DataInicioreal: Date | null,
    DataTerminoreal: Date | null,

    Contato1: string | null,
    Telefone1: string | null,
    Email1: string | null,

    Contato2: string | null,
    Telefone2: string | null,
    Email2: string | null,

    Escopo: string | null,
    DadosEntrada: string | null,
  ): Promise<CreateProjetoResponse> {
    const response = await this.service.createProjeto({
      DescricaoProjeto,
      NumeroContrato,
      IdCentroCusto,
      DataInicio,
      DataTermino,
      DataInicioreal,
      DataTerminoreal,
      Contato1,
      Telefone1,
      Email1,
      Contato2,
      Telefone2,
      Email2,
      Escopo,
      DadosEntrada,
    });
    return response;
  }

  async updateProjeto(
    IdProjeto: number,
    DescricaoProjeto: string | null,
    NumeroContrato: string | null,
    IdCentroCusto: number | null,

    DataInicio: Date | null,
    DataTermino: Date | null,
    DataInicioreal: Date | null,
    DataTerminoreal: Date | null,

    Contato1: string | null,
    Telefone1: string | null,
    Email1: string | null,

    Contato2: string | null,
    Telefone2: string | null,
    Email2: string | null,

    Escopo: string | null,
    DadosEntrada: string | null,
  ): Promise<void> {
    await this.service.updateProjeto({
      IdProjeto,
      DescricaoProjeto,
      NumeroContrato,
      IdCentroCusto,
      DataInicio,
      DataTermino,
      DataInicioreal,
      DataTerminoreal,
      Contato1,
      Telefone1,
      Email1,
      Contato2,
      Telefone2,
      Email2,
      Escopo,
      DadosEntrada,
    });
  }

  async deleteProjeto(IdProjeto: number): Promise<void> {
    await this.service.deleteProjeto({ IdProjeto });
  }

  //#endregion

  //#region Checklist

  async getAllProjetosChecklist(
    currentPage: number,
    rowsPerPage: number,
    nome: string,
    status: number,
  ): Promise<Paginated<ChecklistLista>> {
    const response = await this.service.getAllProjetosChecklist({
      currentPage,
      rowsPerPage,
      nome,
      status,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ChecklistLista => ({
          IdChecklist: item.idChecklist,
          Descricao: item.descricao,
          Nome: item.nome,
          Status: item.status,
        }),
      ),
    };
  }

  async createProjetosChecklist(
    statusCheckList: boolean,
    nome: string,
    descricao: string,
  ): Promise<CreateProjetosChecklistResponse> {
    return await this.service.createProjetosChecklist({
      statusCheckList,
      nome,
      descricao,
    });
  }

  async getByIdProjetosChecklist(
    id: number,
  ): Promise<GetProjetosChecklistByIdResponse> {
    return await this.service.getByIdProjetosChecklist({
      id,
    });
  }

  async updateProjetosChecklist(
    id: number,
    statusCheckList: boolean,
    nome: string,
    descricao?: string,
  ): Promise<UpdateProjetosChecklistResponse> {
    return await this.service.updateProjetosChecklist({
      idChecklist: id,
      statusCheckList,
      nome,
      descricao,
    });
  }

  async deleteProjetosChecklist(
    IdChecklist: number,
  ): Promise<DeleteProjetosChecklistResponse> {
    return await this.service.deleteProjetosChecklist({
      IdChecklist: IdChecklist,
    });
  }

  async getDropDownChecklist(
    request: GetDropDownChecklistRequestModel,
  ): Promise<GetDropDownChecklistResponseModel[]> {
    const response = await this.service.getDropDownChecklist(request);
    return { ...response };
  }

  //#endregion

  //#region Itens Checklist

  async getAllItensChecklist(
    currentPage: number,
    rowsPerPage: number,
    IdChecklist: number,
  ): Promise<Paginated<ItemChecklistLista>> {
    const response = await this.service.getAllItensChecklist({
      currentPage,
      rowsPerPage,
      IdChecklist,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ItemChecklistLista => ({
          IdChecklist: item.idChecklist,
          IdItemChecklist: item.idItemchecklist,
          Descricao: item.descricao ?? "",
          Codigo: item.codigo ?? "",
        }),
      ),
    };
  }

  async createItensChecklist(
    idChecklist: number,
    codigo: string,
    descricao: string,
  ): Promise<CreateItensChecklistResponse> {
    return await this.service.createItensChecklist({
      idChecklist,
      codigo,
      descricao,
    });
  }

  async getByIdItensChecklist(
    id: number,
  ): Promise<GetItensChecklistByIdResponse> {
    return await this.service.getByIdItensChecklist({
      id,
    });
  }

  async updateItensChecklist(
    idItemchecklist: number,
    idChecklist: number,
    codigo: string,
    descricao: string,
  ): Promise<UpdateItensChecklistResponse> {
    return await this.service.updateItensChecklist({
      idItemchecklist,
      idChecklist,
      codigo,
      descricao,
    });
  }

  async deleteItensChecklist(
    IdItemChecklist: number,
  ): Promise<DeleteItensChecklistResponse> {
    return await this.service.deleteItensChecklist({
      IdItemChecklist,
    });
  }

  //#endregion

  //#region ProjetoArquivo

  async getAllProjetoArquivo(
    IdProjeto: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<DocumentoLista>> {
    const response = await this.service.getAllProjetoArquivo({
      IdProjeto,
      page,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DocumentoLista => ({
          IdProjeto: item.idProjeto,
          IdProjetoArquivo: item.idProjetoArquivo,
          Arquivo: item.arquivo,
          Descricao: item.descricao,
          Nome: item.nome,
        }),
      ),
    };
  }

  async getProjetoArquivoById(
    request: GetProjetoArquivoByIdRequestModel,
  ): Promise<Blob> {
    const response = await this.service.getProjetoArquivoById(request);
    return response;
  }

  async createProjetoArquivo(
    IdProjeto: number,
    Descricao: string | null,
    Nome: string | null,
    Arquivo: File | null,
  ): Promise<void> {
    await this.service.createProjetoArquivo({
      IdProjeto,
      Descricao,
      Nome,
      Arquivo,
    });
  }

  async updateProjetoArquivo(
    IdProjetoArquivo: number,
    IdProjeto: number,
    Descricao: string | null,
    Nome: string | null,
    Arquivo: File | null,
  ): Promise<void> {
    await this.service.updateProjetoArquivo({
      IdProjetoArquivo,
      IdProjeto,
      Descricao,
      Nome,
      Arquivo,
    });
  }

  async deleteProjetoArquivo(IdProjetoArquivo: number): Promise<void> {
    await this.service.deleteProjetoArquivo({ IdProjetoArquivo });
  }

  //#endregion

  //#region ProjetoInformacoes

  async getAllProjetoInformacoes(
    request: InformacoesFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<InformacoesLista>> {
    const response = await this.service.getAllProjetoInformacoes({
      IdProjeto: request.IdProjeto,
      Data: request.Data,
      DescInformacoes: request.DescInformacoes,
      page,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): InformacoesLista => ({
          IdProjeto: item.idProjeto,
          IdInformacoes: item.idInformacoes,
          Data: item.data,
          DescInformacoes: item.descInformacoes,
          IdFuncionario: item.idFuncionario,
          NomeFuncionario: item.nomeFuncionario,
        }),
      ),
    };
  }

  async getProjetoInformacoesById(
    request: GetProjetoInformacoesByIdRequestModel,
  ): Promise<ProjetoInformacoesGetByIdModel> {
    const response = await this.service.getProjetoInformacoesById(request);
    return { ...response };
  }

  async createProjetoInformacoes(
    IdProjeto: number,
    DescInformacoes: string | null,
    IdFuncionario: number | null,
    Data: Date | null,
  ): Promise<void> {
    await this.service.createProjetoInformacoes({
      IdProjeto,
      DescInformacoes,
      IdFuncionario,
      Data,
    });
  }

  async updateProjetoInformacoes(
    IdInformacoes: number,
    IdProjeto: number,
    DescInformacoes: string | null,
    IdFuncionario: number | null,
    Data: Date | null,
  ): Promise<void> {
    await this.service.updateProjetoInformacoes({
      IdInformacoes,
      IdProjeto,
      DescInformacoes,
      IdFuncionario,
      Data,
    });
  }

  async deleteProjetoInformacoes(IdInformacoes: number): Promise<void> {
    await this.service.deleteProjetoInformacoes({ IdInformacoes });
  }

  //#endregion
  //#region Disciplina
  async getAllProjetoDisciplina(
    request: DisciplinaFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<DisciplinaLista>> {
    const response = await this.service.getAllProjetoDisciplinas({
      IdProjeto: request.IdProjeto,
      Disciplina: request.Disciplina,
      Por: request.Por,
      Prancha: request.Prancha,
      Revisao: request.Revisao,
      page,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DisciplinaLista => ({
          IdDisciplina: item.idDisciplina,
          IdDisciplinaPai: item.idDisciplinaPai ?? null,
          IdProjeto: item.idProjeto,
          Descricao: item.disciplina ?? null,
          Revisao: item.revisao ?? null,
          Plantas: item.prancha ?? null,
          DataAlteracao: item.data ?? null,
          IdDisciplinaChecklist: item.idDisciplinaChecklist ?? null,
          IdChecklist: item.idChecklist ?? null,
          Path: item.path ?? [],
          Status: item.status ?? null,
          Analise: item.analise ?? null,
          Checklist: item.checklist ?? null,
          AlteradoPor: item.alteradoPor ?? null,
          Tipo: item.tipo ?? null,
          IdFornecedor: item.idFornecedor ?? null,
          IdFuncionario: item.idFuncionario ?? null,
          DescResponsavel: item.descResponsavel ?? null,
          ResponsavelCadastrado: item.responsavelCadastrado ?? null,
          DataInicioPrevisto: (item.datainicioPrevisto as any) ?? null,
          DataInicioReal: (item.datainicioReal as any) ?? null,
          DataFimPrevisto: (item.datafimPrevisto as any) ?? null,
          DataFimReal: (item.datafimReal as any) ?? null,
          Local1: item.local1 ?? null,
          Local2: item.local2 ?? null,
          Local3: item.local3 ?? null,
          Local4: item.local4 ?? null,
          Local5: item.local5 ?? null,
          Local6: item.local6 ?? null,
          UltimaRevisao: item.ultimaRevisao ?? null,
          Arquivo1: (item.arquivo1 as any) ?? null,
          NomeArquivo1: item.nomeArquivo1 ?? null,
          DataInclusao: (item.dataInclusao as any) ?? null,
          IdUsuarioCriacao: item.idUsuarioCriacao ?? null,
          IdUsuarioAlteracao: item.idUsuarioAlteracao ?? null,
          DataDisciplina: item.data ?? null,
          IdCliente: item.idCliente ?? null,
          nCopia1: item.nCopia1 ?? null,
          nCopia2: item.nCopia2 ?? null,
          nCopia3: item.nCopia3 ?? null,
          nCopia4: item.nCopia4 ?? null,
          nCopia5: item.nCopia5 ?? null,
          nCopia6: item.nCopia6 ?? null,
        }),
      ),
    };
  }
  async getProjetoDisciplinaById(
    request: GetProjetoDisciplinaByIdRequestModel,
  ): Promise<GetProjetoDisciplinaByIdResponseModel> {
    const response = await this.service.getProjetoDisciplinaById(request);
    return { ...response };
  }
  async copiaDisciplinas(form: DisciplinaCopiaRequestForm): Promise<void> {
    await this.service.copiaDisciplinas({
      dataDisciplina: form.dataDisciplina ?? null,
      descricao: form.descricao,
      idDisciplina: form.idDisciplina ?? null,
      idProjeto: form.idProjeto ?? null,
      plantas: form.plantas ?? null,
      revisao: form.revisao ?? null,
    });
  }

  async createProjetoDisciplina(
    idProjeto: number,
    idChecklist: number | null,
    tipo: string | null,
    descricao: string | null,
    idFuncionario: number | null,
    idFornecedor: number | null,
    descResponsavel: string | null,
    datainicioPrevisto: Date | null,
    datainicioReal: Date | null,
    datafimPrevisto: Date | null,
    datafimReal: Date | null,
    dataDisciplina: Date | null,
    revisao: string | null,
    plantas: string | null,
    local1: string | null,
    local2: string | null,
    local3: string | null,
    local4: string | null,
    local5: string | null,
    local6: string | null,
    subdiciplina: boolean | null,
    idDisciplinaPai: number | null,
    ultimaRevisao: boolean | null,
    idUsuario: number | null,
    idCliente: number | null,
    nCopia1: string | null,
    nCopia2: string | null,
    nCopia3: string | null,
    nCopia4: string | null,
    nCopia5: string | null,
    nCopia6: string | null,
  ): Promise<CreateProjetoDisciplinaResponse> {
    const response = await this.service.createProjetoDisciplina({
      idProjeto,
      idChecklist,
      tipo,
      descricao,
      idFuncionario,
      idFornecedor,
      descResponsavel,
      datainicioPrevisto,
      datainicioReal,
      datafimPrevisto,
      datafimReal,
      dataDisciplina,
      revisao,
      plantas,
      local1,
      local2,
      local3,
      local4,
      local5,
      local6,
      subdiciplina,
      idDisciplinaPai,
      ultimaRevisao,
      idUsuario,
      idCliente,
      nCopia1,
      nCopia2,
      nCopia3,
      nCopia4,
      nCopia5,
      nCopia6,
    });

    return response;
  }

  async updateProjetoDisciplina(
    idDisciplina: number | null,
    idProjeto: number,
    idChecklist: number | null,
    tipo: string | null,
    descricao: string,
    idFuncionario: number | null,
    idFornecedor: number | null,
    descResponsavel: string | null,
    datainicioPrevisto: Date | null,
    datainicioReal: Date | null,
    datafimPrevisto: Date | null,
    datafimReal: Date | null,
    dataDisciplina: Date | null,
    revisao: string | null,
    plantas: string | null,
    local1: string | null,
    local2: string | null,
    local3: string | null,
    local4: string | null,
    local5: string | null,
    local6: string | null,
    subdiciplina: boolean | null,
    idDisciplinaPai: number | null,
    ultimaRevisao: boolean | null,
    idUsuario: number | null,
    idCliente: number | null,
    nCopia1: string | null,
    nCopia2: string | null,
    nCopia3: string | null,
    nCopia4: string | null,
    nCopia5: string | null,
    nCopia6: string | null,
  ): Promise<void> {
    await this.service.updateProjetoDisciplina({
      idDisciplina,
      idProjeto,
      idChecklist,
      tipo,
      descricao,
      idFuncionario,
      idFornecedor,
      descResponsavel,
      datainicioPrevisto,
      datainicioReal,
      datafimPrevisto,
      datafimReal,
      dataDisciplina,
      revisao,
      plantas,
      local1,
      local2,
      local3,
      local4,
      local5,
      local6,
      subdiciplina,
      idDisciplinaPai,
      ultimaRevisao,
      idUsuario,
      idCliente,
      nCopia1,
      nCopia2,
      nCopia3,
      nCopia4,
      nCopia5,
      nCopia6,
    });
  }

  async deleteProjetoDisciplina(
    request: DeleteProjetoDisciplinaRequestModel,
  ): Promise<DeleteProjetoDisciplinaResponseModel> {
    const response = await this.service.deleteProjetoDisciplina(request);
    return { ...response };
  }

  async getDropDownDisciplina(
    request: GetDropDownDisciplinaRequestModel,
  ): Promise<GetDropDownDisciplinaResponseModel[]> {
    const response = await this.service.getDropDownDisciplina(request);
    return { ...response };
  }

  //#endregion
  async deleteDisciplinaChecklist(
    IdDisciplinaChecklist: number,
  ): Promise<void> {
    await this.service.deleteDisciplinaChecklist({ IdDisciplinaChecklist });
  }

  async getAllDisciplinaItemsChecklist(
    idDisciplinaChecklist: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<DisciplinaItemChecklistLista>> {
    const response = await this.service.getAllDisciplinaItemsChecklist({
      idDisciplinaChecklist,
      page,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): DisciplinaItemChecklistLista => ({
          idDisciplinaItemChecklist: item.idDisciplinaItensChecklist,
          itens: item.itens ?? null,
          descricao: item.descricao ?? null,
          inspecao: item.inspecao ?? "",
          disciplinaChecklist: (item.disciplinaChecklist as any) ?? null,
          conferido: null,
          idDisciplinaChecklist: null,
          idItemChecklist: null,
          naoSeAplica: null,
          status: null,
        }),
      ),
    };
  }

  async updateDisciplinaChecklist(
    request: UpdateDisciplinaChecklistRequestModel,
  ): Promise<UpdateDisciplinaChecklistResponseModel> {
    const response = await this.service.updateDisciplinaChecklist(request);
    return { ...response };
  }

  //#region DisciplinaArquivo

  async getAllDisciplinaArquivos(
    request: GetAllDisciplinasArquivosRequestModel,
  ): Promise<GetAllDisciplinasArquivosResponseModel> {
    const response = await this.service.getAllDisciplinaArquivos(request);
    return { ...response };
  }

  async getByIdDisciplinaArquivo(
    request: GetDisciplinasArquivosByIdRequestModel,
  ): Promise<GetDisciplinasArquivosByIdResponseModel> {
    const response = await this.service.getByIdDisciplinaArquivo(request);
    return { ...response };
  }

  async createDisciplinaArquivo(
    request: CreateDisciplinasArquivosRequestModel,
  ): Promise<CreateDisciplinasArquivosResponseModel> {
    const response = await this.service.createDisciplinaArquivo(request);
    return { ...response };
  }

  async updateDisciplinaArquivo(
    request: UpdateDisciplinasArquivosRequestModel,
  ): Promise<UpdateDisciplinasArquivosResponseModel> {
    const response = await this.service.updateDisciplinaArquivo(request);
    return { ...response };
  }

  async deleteDisciplinaArquivo(
    request: DeleteDisciplinasArquivosRequestModel,
  ): Promise<DeleteDisciplinasArquivosResponseModel> {
    const response = await this.service.deleteDisciplinaArquivo(request);
    return { ...response };
  }

  //#endregion

  //#region ProjetoImpressao
  async getEmailImpressaoParameters(
    idProjetoImpressao: number,
  ): Promise<EmailImpressaoParameters> {
    return await this.service.getEmailImpressaoParameters({
      idProjetoImpressao,
    });
  }

  async sendEmailProjetoImpressao(
    idNovosNegocios: number,
    subject: string,
    emails: string[],
    body: string,
    attachment: string,
  ): Promise<void> {
    await this.service.sendEmailProjetoImpressao({
      idNovosNegocios,
      subject,
      emails,
      body,
      attachment,
    });
  }

  async getAllProjetoImpressao(
    idsProjeto?: number[],
    idsCentrocusto?: number[],
    idsSolicitante?: number[],
    status?: number,
    statusEmail?: number,
    dataDe?: Date,
    dataAte?: Date,

    currentPage?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<ProjetoImpressaoLista>> {
    const response = await this.service.getAllProjetoImpressao({
      idsProjeto,
      idsCentrocusto,
      idsSolicitante,
      status,
      statusEmail,
      dataDe,
      dataAte,

      currentPage,
      rowsPerPage,
    });
    return { ...response };
  }

  async getProjetoImpressaoById(
    idProjetoImpressao: number,
  ): Promise<ImpressaoProjetoModel> {
    const response = await this.service.getProjetoImpressaoById({
      id: idProjetoImpressao,
    });
    return { ...response };
  }

  async createProjetoImpressao(
    idProjeto?: number,
    idCentroCusto?: number,
    idFuncionarioSolicitante?: number,

    dataSolicitacao?: Date,
    quantidade?: number,
    cor?: number,
    tamanho?: string,
    observacoesSolicitacao?: string,
    disciplinasIds?: number[],
  ): Promise<number> {
    const response = await this.service.createProjetoImpressao({
      idProjeto,
      idCentroCusto,
      idFuncionarioSolicitante,
      dataSolicitacao,
      quantidade,
      cor,
      tamanho,
      observacoesSolicitacao,
      disciplinasIds,
    });
    return response.idProjetoImpressao;
  }

  async updateProjetoImpressao(
    idProjetoImpressao: number,

    idFuncionarioAprovacao: number,
    status: number,
    cor: number,
    quantidade: number,
    statusEmail?: number | null,
    dataAprovacao?: Date | null,
    tamanho?: string,
    observacoesSolicitacao?: string,
    idFornecedor?: number | null,
  ): Promise<void> {
    await this.service.updateProjetoImpressao({
      idProjetoImpressao,
      idFuncionarioAprovacao,
      status,
      cor,
      quantidade,
      statusEmail,
      dataAprovacao,
      tamanho,
      observacoesSolicitacao,
      idFornecedor,
    });
  }

  async deleteProjetoImpressao(request: { id: number }): Promise<void> {
    await this.service.deleteProjetoImpressao(request);
  }

  //#endregion

  //#region ProjetoRevisao

  async getAllProjetoRevisao(
    idsProjeto?: number[],
    idsCentrocusto?: number[],
    idsSolicitante?: number[],
    status?: number[],
    dataDe?: Date,
    dataAte?: Date,

    currentPage?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<ProjetoRevisaoLista>> {
    const response = await this.service.getAllProjetoRevisao({
      idsProjeto,
      idsCentrocusto,
      idsSolicitante,
      status,
      dataDe,
      dataAte,
      currentPage,
      rowsPerPage,
    });

    return { ...response };
  }

  async getProjetoRevisaoById(
    idProjetoRevisao: number,
  ): Promise<ProjetoRevisaoModel> {
    const response = await this.service.getProjetoRevisaoById({
      id: idProjetoRevisao,
    });
    return { ...response };
  }

  async createProjetoRevisao(
    idProjeto: number,
    idCentroCusto: number,
    idFuncionarioSolicitante: number,
    dataSolicitacao?: Date,
    descricao?: string,

    nomeArquivo1?: string,
    arquivo1?: File | null,
    nomeArquivo2?: string,
    arquivo2?: File | null,
    disciplinasIds?: number[],
  ): Promise<number> {
    const response = await this.service.createProjetoRevisao({
      idProjeto,
      idCentroCusto,
      idFuncionarioSolicitante,
      dataSolicitacao,
      descricao,
      nomeArquivo1,
      arquivo1,
      nomeArquivo2,
      arquivo2,
      disciplinasIds,
    });

    return response.idProjetoRevisao;
  }

  async updateProjetoRevisao(
    idProjetoRevisao: number,
    status?: number,
    idFuncionarioAprovacao?: number,
    observacoesAprovacao?: string,
    dataAprovacao?: Date,
    dataTermino?: Date,
  ): Promise<void> {
    await this.service.updateProjetoRevisao({
      idProjetoRevisao,
      status,
      idFuncionarioAprovacao,
      observacoesAprovacao,
      dataAprovacao,
      dataTermino,
    });
  }

  async getDisciplinasSubdisciplinasByProjeto(
    idProjeto: number,
    tipo?: number | null,
    prancha?: string | null,
    revisao?: string | null,
    descricao?: string | null,
  ): Promise<DisciplinasSubdisciplinasLista[]> {
    const response = await this.service.getDisciplinasSubdisciplinasByProjeto({
      idProjeto,
      tipo,
      prancha,
      revisao,
      descricao,
    });

    return response.itens.map(
      (item): DisciplinasSubdisciplinasLista => ({
        idDisciplina: item.idDisciplina,
        descricao: item.descricao,
      }),
    );
  }

  async deleteProjetoRevisao(request: { id: number }): Promise<void> {
    await this.service.deleteProjetoRevisao(request);
  }

  //#endregion

  //#region Projeto Revisao Resumo
  async getAllProjetoRevisaoResumo(
    idProjeto?: number | null,
    idDisciplina?: number | null,
    page?: number,
    rowsPerPage?: number,
  ): Promise<Paginated<ProjetoRevisaoResumoLista>> {
    const response = await this.service.getAllProjetoRevisaoResumo({
      idProjeto,
      idDisciplina,
      page,
      rowsPerPage,
    });
    return {
      ...response,
      items: response.items.map(
        (item): ProjetoRevisaoResumoLista => ({
          idProjetoRevisaoResumo: item.idProjetoRevisaoResumo,
          idDisciplina: item.idDisciplina,
          idFuncionario: item.idFuncionario,
          idProjeto: item.idProjeto,
          data: item.data,
          descricao: item.descricao,
          nomeResponsavel: item.nomeResponsavel,
          responsavel: item.responsavel,
        }),
      ),
    };
  }

  async createProjetoRevisaoResumo(
    idProjeto: number | null,
    idDisciplina: number | null,
    descricao: string | null,
    responsavel: string | null,
    idFuncionario: number | null,
    data: Date | null,
  ): Promise<void> {
    await this.service.createProjetoRevisaoResumo({
      idProjeto,
      idDisciplina,
      descricao,
      responsavel,
      idFuncionario,
      data,
    });
  }

  async updateProjetoRevisaoResumo(
    idProjetoRevisaoResumo: number,
    idProjeto: number | null,
    idDisciplina: number | null,
    descricao: string | null,
    responsavel: string | null,
    idFuncionario: number | null,
    data: Date | null,
  ): Promise<void> {
    await this.service.updateProjetoRevisaoResumo({
      idProjetoRevisaoResumo,
      idProjeto,
      idDisciplina,
      descricao,
      responsavel,
      idFuncionario,
      data,
    });
  }

  async deleteProjetoRevisaoResumo(
    IdProjetoRevisaoResumo: number,
  ): Promise<void> {
    await this.service.deleteProjetoRevisaoResumo({ IdProjetoRevisaoResumo });
  }

  async downloadProjetoRevisaoArquivoById(
    id: number,
    nroArquivo: number,
  ): Promise<Blob> {
    const response = await this.service.downloadProjetoRevisaoArquivoById({
      id,
      nroArquivo,
    });
    return response;
  }

  //#endregion

  async sendEmailProjeto(
    idProjeto: number,
    emails: string[],
    subject: string,
    body: string,
    emailAttachment: string,
  ): Promise<void> {
    await this.service.sendEmailProjeto({
      idProjeto,
      emails,
      subject,
      body,
      emailAttachment,
    });
  }

  async getDisciplinaArquivoById(
    idDisciplinaArquivo: number,
    imagePosition: number,
  ): Promise<Blob> {
    const response = await this.service.getDisciplinaArquivoById({
      idDisciplinaArquivo,
      imagePosition,
    });
    return response;
  }

  async getArqDisciplinaChecklist(
    model: UpdateDisciplinaChecklistRequestModel,
  ): Promise<Blob> {
    const response = await this.service.getArqDisciplinaChecklist(model);
    return response;
  }

  //#region Dashboard
  async getDashboardProjetosInfo(): Promise<DashboardProjetosInfo> {
    const response = await this.service.getDashboardProjetosInfo({});
    return { ...response };
  }

  //#endregion
}
